import { render, staticRenderFns } from "./account_remove.vue?vue&type=template&id=339fdc33&scoped=true&"
import script from "./account_remove.vue?vue&type=script&lang=js&"
export * from "./account_remove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339fdc33",
  null
  
)

export default component.exports